import React, { useState, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/contact.png";
import "animate.css";
import TrackVisibility from "react-on-screen";
import emailjs from "@emailjs/browser";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const Contact = () => {
  const [formContent, setFormContent] = useState({});
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_a7j6zs4",
        "template_hhxpc3p",
        form.current,
        "_aUN6kS6mrpH9Upm1"
      )
      .then(
        (result) => {
          console.log(result.text);
          toast.success("Message sent successfully!");
          setFormContent({});
        },
        (error) => {
          console.log(error.text);
          toast.error("Message failed to send. Please try again.");
        }
      )
      .finally(() => {
        // Explicitly reset the form fields, including textarea
        form.current.reset();

        // Ensure textarea value is cleared in state
        setFormContent((prevState) => ({
          ...prevState,
          message: "",
        }));
      });
  };

  const handleChange = (event) => {
    const { value, name } = event.target;

    setFormContent((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) => <img src={contactImg} alt="Contact Us" />}
            </TrackVisibility>
          </Col>
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div>
                  <div className="container">
                    <h2>Get In Touch</h2>
                    <form ref={form} onSubmit={sendEmail}>
                      <Row>
                        <Col size={12} sm={6} className="px-1">
                          <input
                            type="text"
                            name="from_fname"
                            value={formContent.name}
                            placeholder="First Name"
                            onChange={handleChange}
                          />
                        </Col>
                        <Col size={12} sm={6} className="px-1">
                          <input
                            type="text"
                            name="from_lname"
                            value={formContent.name}
                            placeholder="Last Name"
                            onChange={handleChange}
                          />
                        </Col>
                        <Col size={12} sm={6} className="px-1">
                          <input
                            type="email"
                            name="from_email"
                            value={formContent.email}
                            placeholder="Email Address"
                            onChange={handleChange}
                          />
                        </Col>
                        <Col size={12} sm={6} className="px-1">
                          <input
                            type="tel"
                            name="phone_no"
                            value={formContent.phone}
                            placeholder="Phone No."
                            onChange={handleChange}
                          />
                        </Col>
                        <Col size={12} className="px-1">
                          <textarea
                            rows="6"
                            name="message"
                            value={formContent.message}
                            onChange={handleChange}
                            placeholder="Message"
                          ></textarea>
                          <button type="submit" value="Send">
                            <span>SEND</span>
                          </button>
                        </Col>
                      </Row>
                    </form>
                  </div>
                  <ToastContainer />
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
